module.exports = __webpack_public_path__ + "static/homepage5-7d3d2b7787f017c550628f82c2b5e38f.mp4";